import './homepage.css';
import faceLogo from '../images/face_logo.png';
import WorkSelector from './WorkSelector';
import Button from '../components/Button/Button';
import Character from '../components/Character/Character';
import resume from '../media/Heather Carminati_Resume.pdf';

function HomePage() {
  return (
    <div className="HomePage">
      <div className="introduction">
        <img src={faceLogo} alt="Heather face graphic logo" className="face-logo" />
        <div className="intro-text">
          <h1>Hi and welcome, I'm Heather.</h1>
          <p>I'm a computer science <span className="role">master's graduate</span>, a <span className="role">frontend developer</span>, and a <span className="role">creative</span>. </p>
          {/* <p>I'm a master's student in computer science, a web developer, and a creative. </p> */}
        </div>
      </div>

      <div id="work" className="selected-work">
        <h2>Selected Work</h2>
        <WorkSelector />
      </div>

      <div id="about-me" className="about-me">
        <h2>About Me</h2>
        <span className="job-badge">SWE I @ CarGurus</span>
        <p>I've always been driven by curiosity and a passion for learning. Professionally, I'm a software engineer and frontend developer passionate about driving meaningful solutions and inspiring innovation. But beyond my code, I love all things art, drawing, and learning new creative skills. </p>
        <p>Want to see more of my creative adventures? Click below!</p>
        <Button
          onClick={() => window.location = '/play'}
        >
          Explore My Hobbies
        </Button>
      </div>

      <div id="connect" className="connect">
        <div className="connect-content">
          <div className="connect-text">
            <h2>Let's Connect</h2>
            <p>Feel free to reach out, I'm always open to discussing new opportunities or collaborations!</p>
            <div className="connect-buttons">
              <Button
                onClick={() => window.location = 'mailto:hscarminati@hotmail.com'}
              >
                Email Me
              </Button>
              <Button
                onClick={() => window.location = 'https://www.linkedin.com/in/hcarminati/'}
              >
                LinkedIn
              </Button>
              <Button
                onClick={() => window.open(resume, '_blank')}
              >
                Resume
              </Button>
                            <Button
                onClick={() => window.open('https://github.com/hcarminati', '_blank')}
              >
                GitHub
              </Button>
              <Button
                onClick={() => window.open('https://x.com/cvrminati', '_blank')}
              >
                Twitter
              </Button>
            </div>
          </div>
          <Character />
        </div>
      </div>

    </div>
  );
}

export default HomePage;
